export default {
  appID: 'duplicatefinder'
}
